import axios from "axios";
import { FETCH_VIRTUAL_VISIT_REQUESTS, interceptor, UPDATE_VIRTUAL_VISIT_REQUEST_STATUS } from ".";

import store from "../store";
interceptor(axios, store);

export function fetchVirtualVisitRequests() {
  return {
    type: FETCH_VIRTUAL_VISIT_REQUESTS,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/calendly/`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id,
      },
    }),
  };
}

export function updateVirtualVistRequestStatus(id, status) {
  return {
    type: UPDATE_VIRTUAL_VISIT_REQUEST_STATUS,
    payload: axios.put(
      `${process.env.REACT_APP_API_ENDPOINT}/core/calendly/updateVirtualVistRequestStatus/${id}`,
      { status: status },
      {
        headers: {
          Authorization: store.getState().cognito.token,
          PetShopId: store.getState().petShopReducer.currentPetshop.id,
        },
      }
    ),
  };
}
